export const translateErrorMsg = {
  translateMsg: function(msg) {
    // console.log('global??')
    //console.log(msg)

    if (msg.startsWith('@#=#@@=$#')) {
      const erorrMsg = msg.split('@=$#')
      //console.log(erorrMsg[2])
      return erorrMsg[2].replace(/\s/g, '')
    } else {
      if (msg == '@#=#@@=$#43@=$#Merchant Not Found@=$#0') {
        return 'merchantCodeNotFound'
      } else if (msg == 'Merchant Code Not Found') {
        return 'merchantCodeNotFound'
      } else if (msg == 'User Name Cannot be empty') {
        return 'UserNameCannotBeEmpty'
      } else if (msg == 'Password Cannot be empty') {
        return 'PasswordCannotBeEmpty'
      } else if (msg == 'Invalid Username Or Password') {
        return 'InvalidUsernameOrPassword'
      } else if (msg == 'Stall Code cannot be empty') {
        return 'StallCodecannotBeEmpty'
      } else if (msg == 'Stall Name cannot be empty') {
        return 'StallNameCannotBeEmpty'
      } else if (msg == 'Name Already In Used') {
        return 'NameAlreadyInUsed'
      } else if (msg == 'Stall Not Found, Please Select a Stall') {
        return 'StallNotFound'
      } else if (msg == 'User Password cannot be empty') {
        return 'UserPasswordCannotBeEmpty'
      } else if (msg == 'User Password does not match Confirm Password') {
        return 'UserPasswordNotMatchConfirmPassword'
      } else if (msg == 'Image width & heigth must be at least 600px!') {
        return 'ImageAtLeast600px'
      } else if (msg == 'Image must be square!') {
        return 'ImageMustBeSquare'
      } else if (msg == 'Price Name cannot be empty!') {
        return 'PriceNameCannotBeEmpty'
      } else if (msg == 'Price Name cannot be duplicated!') {
        return 'PriceNameCannotBeDuplicated'
      } else if (msg == 'Property Name cannot be empty!') {
        return 'PropertyNameCannotBeEmpty'
      } else if (msg == 'Property Name cannot be duplicated!') {
        return 'PropertyNameCannotBeDuplicated'
      } else if (msg == 'Menu Item Name cannot be empty.') {
        return 'MenuItemNameCannotBeEmpty'
      } else if (msg == 'Menu Item Category Name cannot be empty.') {
        return 'MenuItemCategoryNameCannotBeEmpty'
      } else if (msg == 'Please set at least one price') {
        return 'PleaseSetAtLeastOnePrice'
      } else if (msg == 'Sender Token Cannot Be Empty') {
        return 'SenderTokenCannotBeEmpty'
      } else if (msg == 'Chat Account Token Cannot Be Empty') {
        return 'ChatAccountTokenCannotBeEmpty'
      } else if (msg == 'New Password and Confirm Password Not Match') {
        return 'NewPasswordAndConfirmPasswordNotMatch'
      } else if (msg == 'New Password Cannot Be Empty') {
        return 'NewPasswordCannotBeEmpty'
      } else if (msg == 'The picture should be a horizontal rectangle!') {
        return 'ThePictureShouldBeHorizontalRectangle'
      } else {
        return ''
      }
    }
  },

  titleName: function(title) {
    if (title == 'Stall') {
      return 'Stall'
    } else if (title == 'User') {
      return 'User'
    } else if (title == 'Order') {
      return 'Order'
    } else if (title == 'Menu') {
      return 'Menu'
    } else if (title == 'Report') {
      return 'Report'
    } else if (title == 'KtnConfig') {
      return 'Setting'
    } else if (title == 'OrderList') {
      return 'History'
    } else if (title == 'ChangePassword') {
      return 'ChangePassword'
    } else if (title == 'MchtConfig') {
      return 'Setting'
    } else if (title == 'Account') {
      return 'Account'
    } else {
      return ''
    }
  }
}
